import { HomeOutlined, PhoneOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

export default function PrivacyPolicyPage() {
  const nav = useNavigate();

  return (
    <div className="flex flex-col  bg-[#19181c] text-white px-6 w-full py-16">
      <Helmet>
        <title>Scryptworx Studios | Privacy Policy</title>
        <meta name="description" content="Scryptworx Studios Privacy Policy" />
        <meta name="keywords" content="privacy, policy, data, security" />
        <meta name="author" content="Scryptworx Studios" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="canonical" href="https://scryptworxstudios.com/privacy" />
        <meta name="robots" content="index, follow" />
         <meta property="og:title" content="Scryptworx Studios | Privacy Policy" />
        <meta property="og:description" content="Scryptworx Studios Privacy Policy" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://scryptworxstudios.com/privacy" />
        <meta property="og:image" content="https://scryptworxstudios.com/oapple-touch-icon.png" />
         <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Scryptworx Studios | Privacy Policy" />
        <meta name="twitter:description" content="Scryptworx Studios Privacy Policy" />
        <meta name="twitter:image" content="https://scryptworxstudios.com/apple-touch-icon.png" />

      </Helmet>
      <div className="max-w-4xl mx-auto h-full">
        <div className="mb-12">
          <h1 className="text-5xl font-bold mb-4 text-[#F6B34B]">
            Privacy Policy
          </h1>
          <p className="text-white/70 text-sm">Last updated: May 12, 2026</p>
        </div>

        <div className="space-y-10 text-white/90 leading-8">
          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Overview
            </h2>
            <p>
              This application is a private internal tool used exclusively by
              authorized members of our organization to publish and manage
              content on Facebook Pages owned and operated by our company.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Information We Collect
            </h2>
            <p className="mb-4">
              The application may access limited Facebook account and Page data
              necessary to perform publishing functionality.
            </p>

            <ul className="list-disc pl-6 space-y-2 text-white/80">
              <li>Facebook Page access tokens</li>
              <li>Facebook Page IDs and metadata</li>
              <li>Post content submitted for publishing</li>
              <li>Basic account information provided through Facebook Login</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              How Information Is Used
            </h2>
            <p className="mb-4">
              Information is used solely for the purpose of:
            </p>

            <ul className="list-disc pl-6 space-y-2 text-white/80">
              <li>Authenticating authorized users</li>
              <li>Publishing posts to Facebook Pages</li>
              <li>Managing automated publishing workflows</li>
              <li>Maintaining operational logs and diagnostics</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Data Sharing
            </h2>
            <p>
              We do not sell, rent, or share personal information with third
              parties except where required to operate Facebook platform
              functionality or comply with legal obligations.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Data Retention
            </h2>
            <p>
              Access tokens and operational data are retained only as long as
              necessary to operate the application and maintain security,
              auditing, and troubleshooting capabilities.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Security
            </h2>
            <p>
              Reasonable technical and organizational measures are implemented
              to protect access credentials and operational data from
              unauthorized access, disclosure, or misuse.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Third-Party Services
            </h2>
            <p>
              This application integrates with Facebook services and APIs. Users
              are also subject to Facebook's own terms, policies, and privacy
              practices.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Changes To This Policy
            </h2>
            <p>
              This Privacy Policy may be updated periodically to reflect changes
              in functionality, operational practices, or legal requirements.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Contact
            </h2>
            <p>
              For questions regarding this Privacy Policy or the operation of
              this application, please contact your organization administrator.
            </p>
            <div className="flex justify-end gap-4 mt-6">
              <Button
                type="primary"
                size="large"
                onClick={() => nav("/contact")}
                className="text-white hover:bg-[#F6B34B]/90 transition-colors"
              >
                <PhoneOutlined style={{ marginRight: "0.5rem" }} />
                CONTACT US
              </Button>
              <Button type="default" size="large" onClick={() => nav("/")}>
                <HomeOutlined style={{ marginRight: "0.5rem" }} />
                HOME
              </Button>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
